import VaultIcon from '../../../../../assets/subscriptions/vault.svg';
import { BoxedIconVariants } from '../../../../../shared/boxed-icon';
import Box from '@mui/material/Box';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import AddToDrive from '@mui/icons-material/AddToDrive';
import FeedOutlined from '@mui/icons-material/FeedOutlined';
import EmailOutlined from '@mui/icons-material/EmailOutlined';
import PhonelinkRingOutlined from '@mui/icons-material/PhonelinkRingOutlined';
import PeopleAltOutlined from '@mui/icons-material/PeopleAltOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';

export interface ActionIcon {
  icon: React.ReactNode;
  variant: BoxedIconVariants;
}

const iconStyle = {
  width: 20,
  height: 20,
};

export const getActionIcon = (groupTypeValue: string): ActionIcon => {
  switch (groupTypeValue) {
    case 'Vault':
      return {
        icon: (
          <Box
            component="img"
            src={VaultIcon}
            alt="Vault"
            sx={{
              width: iconStyle.width,
              height: iconStyle.height,
              filter:
                'brightness(0) saturate(100%) invert(52%) sepia(91%) saturate(2000%) hue-rotate(199deg)',
            }}
          />
        ),
        variant: 'blue',
      };
    case 'Calendars':
      return {
        icon: <CalendarTodayOutlined />,
        variant: 'violet',
      };
    case 'Drive':
      return {
        icon: <AddToDrive />,
        variant: 'amber',
      };
    case 'Documents':
      return {
        icon: <FeedOutlined />,
        variant: 'blueDark',
      };
    case 'Gmail':
      return {
        icon: <EmailOutlined />,
        variant: 'rose',
      };
    case 'Mobile Management':
      return {
        icon: <PhonelinkRingOutlined />,
        variant: 'green',
      };
    case 'User':
      return {
        icon: <PeopleAltOutlined />,
        variant: 'green',
      };
    default:
      return {
        icon: <PersonOutlined />,
        variant: 'blueDark',
      };
  }
};
